import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=c5630774&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"
import style0 from "./agreement.vue?vue&type=style&index=0&id=c5630774&prod&scoped=true&lang=less"
import style1 from "./agreement.vue?vue&type=style&index=1&id=c5630774&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5630774",
  null
  
)

export default component.exports